import { Link } from "react-router-dom";
import Aos from "../aos/aos";
const Experience = () => {
    Aos(1000)
    return (
        <div className="w-full px-4 py-4 mt-4 rounded-lg bg-white/30 backdrop-blur flex flex-col space-y-4 justify-center items-center">
            <div className="text-center font-mono text-xl text-yellow-500 font-bold " data-aos="fade-down">WORK EXPERIENCE</div>
            <div className="flex w-full" data-aos="zoom-in">
                    <div className="w-[20%] text-xl font-extrabold text-yellow-400">2021 till date</div>
                    <div className="flex flex-col w-[80%]">
                        <div className="text-white font-bold font-mono">DEVELOPER/CEO</div>
                        <div className="text-gray-400 font-bold">Udokez Developers</div>
                        <div className="text-black text-justify">As CEO and Developer at Udokez Developers,
                            I have spearheaded the creation of 40+ web applications which includes blog sites, VTU platforms, hotel bookings, and portfolios. My role involves hands-on coding, problem-solving, and strategic project management.
                            My diverse portfolio reflects my commitment to excellence and client satisfaction. </div>
                    </div>
                </div>
            <div className="flex w-full" data-aos="zoom-in">
                <div className="w-[20%] text-xl font-extrabold text-yellow-400">2021 till date</div>
                <div className="flex flex-col w-[80%]">
                    <div className="text-white font-bold font-mono">FREELANCER</div>
                    <div className="text-gray-400 font-bold">Upwork/Fiverr</div>
                    <div className="text-black text-justify">
                        I am an experienced freelancer/web developer who have delivered 30+ customized applications which includes
                         blog, business, restaurant, and e-commerce websites.
                        I am known for exceeding client expectations through efficient project management
                        and responsive solutions.
                    </div>
                </div>
                
            </div>
            <Link reloadDocument to="/projects" className="py-2 px-2 text-white focus:translate-y-2 bg-gray-400 shadow-md shadow-white rounded-lg">View Projects</Link>
        </div>
    );
}

export default Experience;